import { Link } from 'react-router-dom';

import LinkButton from '@/shared/components/UI/LinkButton';
import Button from '@/shared/components/UI/Button';
import { useAuthStore } from '@/shared/stores/useAuthStore';
import { useUserStore } from '@/shared/stores/useUserStore';

const MyPageNav = () => {
  const clearToken = useAuthStore((state) => state.clearToken);
  const clearUserData = useUserStore((state) => state.clearUserData);

  const logOut = () => {
    clearToken();
    clearUserData();
    sessionStorage.clear();
  };

  return (
    <div className="w-full max-w-[10.5rem]">
      <Link to="/mypage">
        <h2 className="mb-5 text-[1.25rem] font-extrabold text-[#95699f]">
          My Page
        </h2>
      </Link>
      <ul>
        <li className="h-9 cursor-pointer py-2">
          <LinkButton
            to="/mypage/account"
            variant="text"
            className="text-[1.125rem] font-medium text-[#4b5563]"
          >
            My Account
          </LinkButton>
        </li>
        <li className="h-9 cursor-pointer py-2">
          <LinkButton
            to="/mypage/shoppinginfo"
            variant="text"
            className="text-[1.125rem] font-medium text-[#4b5563]"
          >
            Shopping Info
          </LinkButton>
        </li>
      </ul>
      <Button
        type="button"
        variant="secondary"
        size="xs"
        onClick={logOut}
        className="mt-6 w-[106px] bg-[#4b5563] hover:bg-[#222]"
      >
        LOG OUT
      </Button>
    </div>
  );
};

export default MyPageNav;
